export class UploadDuplicateData {
    filename: string = "";
    sitename: string = "";
    fileid: number = 0;
 
    parentFolderId:number
    siteId:number
    uploadPath:string=""
    duplicateFileDetectionLevel:number
}